import { API } from 'aws-amplify';

const orderSignRiders = async data => {
  const order = await API.post('agentbuzz', 'signriders', {
    body: createSignRiderData(data),
  });
  return order;
};

const createSignRiderData = data => {
  const signRiderData = {
    email: data.email,
    teamId: data.teamId,
    phoneNumber: data.userPhoneNumber,
    localPhoneNumber: modPhoneNumber(data.selectedPhoneNumber),
    template: {
      id: data.template.id,
      s3Key: data.template.s3Key,
      styles: data.template.styles,
    },
    signRider: {
      name: data.shippingAddress.name,
      shippingAddress: data.shippingAddress,
      shippingSpeed: data.shippingSpeed,
      size: getSizeVal(data.selectedSignRiderSize),
      material: data.selectedSignRiderMaterial,
      grommetHoles: data.selectedSignRiderGrommetHoles,
      additionalInfo: data.additionalInfo || null,
    },
  };
  return signRiderData;
};

const modPhoneNumber = phoneNumber => {
  return phoneNumber.split('').reduce((number, currNumber, i) => {
    if (i >= 2) {
      i === 5 || i === 8
        ? (number += `-${currNumber}`)
        : (number += currNumber);
    } else {
      number = '';
    }
    return number;
  });
};

//refactor the below function, it's being used in NewSignRiderWizard too.
function getSizeVal(sizeString) {
  if (sizeString.includes('Custom')) {
    return 'custom';
  } else {
    return sizeString;
  }
}

export default orderSignRiders;



// WEBPACK FOOTER //
// ./src/services/signrider/orderSignRiders.js